export default __webpack_public_path__ + "static/media/owl-logo-blue.60197aae.svg";